export function isRepPayee(cardProgramNumber) {
  return [3, 4].includes(cardProgramNumber);
}

export function isAbleActAccount(cardProgramNumber) {
  return [8, 9, 12].includes(cardProgramNumber);
}
